<template v-if="isAuthenticated !== null">
  <div v-if="isPopUpMenuOpen" class="popup-menu-overlay" @click="togglePopUpMenu"></div>
  <!-- Popup Menu -->
  <div v-if="isPopUpMenuOpen" class="popup-menu">
    <ul>
      <li v-for="(item, index) in popUpMenuItems" :key="index" @click="handlePopUpMenuItemClick(item)">
        {{ item }}
      </li>
    </ul>
  </div>
  <div id="header">
    <nav class="navbar">
      <img v-if="isAuthenticated" src="assets/icons/menu.svg" class="burger-menu" alt="Menu" @click="openMenu" />
      <span class="bot-name" @click.exact="navigateToHome" @click.ctrl="openCreditsModal">
        <img src="assets/icons/robot.svg">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="var(--primary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-bot-icon w-8 h-8 text-red-500">
          <path d="M12 8V4H8"></path>
          <rect width="16" height="12" x="4" y="8" rx="2"></rect>
          <path d="M2 14h2"></path>
          <path d="M20 14h2"></path>
          <path d="M15 13v2"></path>
          <path d="M9 13v2"></path>
        </svg> -->
        <span>10-4</span>
      </span>
    </nav>
    <div class="d-flex-justify-center-align-center">
      <!-- <ButtonComponent v-if="!isAuthenticated" type="primary" content="Login" iconPath="assets/icons/discord.svg"
        @click="login" /> -->
      <img v-if="isAuthenticated && avatarURL" :src="avatarURL"
        :class="{ 'user-avatar': true, 'active': isPopUpMenuOpen }" @click="togglePopUpMenu" />
    </div>
  </div>
  <ModalComponent :isVisible="isCreditsModalVisible" title="10-4" :closeAction="closeCreditsModal"><label>Made with ❤️
      by <a href="https://anthonylevesque.ca">WaterPolo</a></label>
  </ModalComponent>
</template>

<script>
import ModalComponent from './ModalComponent.vue';
export default {
  name: 'HeaderBar',
  components: {
    ModalComponent
  },
  data() {
    return {
      isCreditsModalVisible: false,
      isPopUpMenuOpen: false,
      popUpMenuItems: ['Logout']
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    avatarURL() {
      return localStorage.getItem('10-4-AvatarURL');
    },
    username() {
      return localStorage.getItem('10-4-Username');
    },
  },
  methods: {
    navigateToHome() {
      this.$router.push('/bot');
    },
    openCreditsModal() {
      this.isCreditsModalVisible = true;
    },
    closeCreditsModal() {
      this.isCreditsModalVisible = false;
    },
    goBack() {
      if (window.history.length > 1) {
        if (window.history.state?.back) {
          this.$router.go(-1);
        } else {
          this.$router.push('/bot');
        }
      } else {
        this.$router.push('/bot');
      }
    },
    openMenu() {
      this.$emit('open-menu');
    },
    login() {
      fetch('http://localhost:3000/api/auth/login', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => response.json())
        .then(data => {
          window.location.href = data.url;
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    },
    togglePopUpMenu() {
      this.isPopUpMenuOpen = !this.isPopUpMenuOpen;
    },
    handlePopUpMenuItemClick(item) {
      if (item == "Logout") {
        localStorage.removeItem('10-4-Token');
        localStorage.removeItem('10-4-Username');
        localStorage.removeItem('10-4-AvatarURL');
        this.$store.dispatch('logout');
        this.$router.push('/bot');
      }

      this.isPopUpMenuOpen = false;
    }
  }
}

</script>

<style scoped>
#header {
  position: sticky;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5.5px);
  padding-right: 50px;
  padding-left: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  justify-content: space-between;
  height: var(--header-height);
}

.bot-name {
  font-size: 18px;
  display: flex;
  align-items: center;
  font-weight: 600;

  img {
    padding-right: 10px;
  }

  :hover {
    cursor: pointer;
  }
}

.navbar {
  padding: 1rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-avatar {
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  border: 2px solid var(--color-100);

  &.active {
    border: 2px solid var(--color-400);
  }

  &:hover {
    cursor: pointer;
    border: 2px solid var(--color-400);
  }
}

.d-flex-justify-center-align-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.burger-menu {
  cursor: pointer;
  margin-right: 12px;
}

/** PopUpMenu */
.popup-menu {
  position: absolute;
  top: 60px;
  right: 0;
  background-color: var(--secondary);
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 2;
}

.popup-menu ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  z-index: 2;
}

.popup-menu li {
  padding: 10px;
  cursor: pointer;
  margin: 6px;
  border-radius: 4px;
  z-index: 2;
}

.popup-menu li:hover {
  background-color: var(--color-600);
}

.popup-menu-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}

@media (max-width: 768px) {
  #header {
    padding-right: 1rem;
    padding-left: 1rem;
  }

  .bot-name {
    font-size: 16px;
  }

  .bot-name img {
    padding-right: 6px;
    width: 24px;
    height: 24px;
  }

  .popup-menu {
    right: 1rem;
  }
}
</style>
